import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SendShippingEmailRequest } from '../entities/shipping-accounting.entity';
import { ShippingAccountingRepository } from '../interfaces/shipping-accounting-repository.interface';

@Injectable()
export class SendShippingEmailUseCase {
  constructor(private readonly repository: ShippingAccountingRepository) {}

  execute(request: SendShippingEmailRequest): Observable<void> {
    return this.repository.sendEmail(request);
  }
}
